export default __webpack_public_path__ + "static/media/blue-plus-small.98597f12.svg";